// Small presentation helpers for the stats surfaces.

export function num(n: number | null | undefined): string {
  return n == null ? "—" : n.toLocaleString();
}

/** 0..1 fraction → whole-percent string. */
export function pct(x: number | null | undefined): string {
  return x == null ? "—" : `${Math.round(x * 100)}%`;
}

/** Already-a-percent (0..100) → rounded string. */
export function pct100(x: number | null | undefined): string {
  return x == null ? "—" : `${Math.round(x)}%`;
}

/** Tier slug "apprentice_ii" → "Apprentice II". */
export function tierLabel(slug: string | null | undefined): string {
  if (!slug) return "Unranked";
  const parts = slug.split("_");
  const family = parts[0] ? parts[0][0].toUpperCase() + parts[0].slice(1) : slug;
  const rung = parts[1] ? parts[1].toUpperCase() : "";
  return rung ? `${family} ${rung}` : family;
}

export function flagClasses(flag: string): string {
  switch (flag) {
    case "weak":
      return "bg-red-50 text-red-600 ring-red-200";
    case "strong":
      return "bg-emerald-50 text-emerald-600 ring-emerald-200";
    default:
      return "bg-black/5 text-ink-soft ring-black/10";
  }
}

/** Prettify a topic slug for display when no title is available. */
export function prettySlug(slug: string): string {
  return slug
    .replace(/[-_.]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}
